import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";

export const Columns = (
  onClick: (e: any) => void,
  setPessoaId: (e: any) => void,
  setNomeUsuario: (e: any) => void,
  setTipoPessoa: (e: any) => void,

  filteredInfo: {
    nomeUsuario?: string[] | null;
    tipoPessoa?: string[] | null;
     celular?: string[] | null; 
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Pessoa",
      dataIndex: "nomeUsuario",
      key: "nomeUsuario",
      width: "80%",
      filteredValue: filteredInfo.nomeUsuario || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.nomeUsuario.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nomeUsuario" }),
    },
{
  title: "Celular",
  dataIndex: "celular",
  key: "celular",
  width: "20%",
  filteredValue: filteredInfo.celular || null, // ✅ aqui!
  onFilter: (value, record) =>
    String(record.celular ?? "").includes(String(value)),
  render: (value: string) => value ?? "N/A",
  ...ColumnSearch<any>({ dataIndex: "celular" }),
},


    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setPessoaId(row.id);
                setNomeUsuario(row.nomeUsuario);
                setTipoPessoa(row.tipoPessoa);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
